// import { Elm } from './Main.elm';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { initLayout } from './layout';
var layoutInitializer = initLayout();
import axios from 'axios';
import { editors } from './editor';
import { storage } from './storage';
// import * as monaco from 'monaco-editor';
var lastEvalEditorState = '> ';
var lastEditorState = lastEvalEditorState;
var immutableEditorContext = lastEvalEditorState;
var ignoreInput = false;
var locked = false;
var history = [];
var historyIdx = 1;
function processSource(source) {
    var linebreak = /\r\n|\n\r|\n|\r/g;
    var comments = /(--[^\n\r]*)/g;
    var emptylines = /^(?:[\t ]*(?:\r?\n|\r))+/gm;
    var moduleHeader = /\s*module *[A-Z][\w\d]*.*/g;
    var reduced = source.replace(comments, '')
        .replace(emptylines, '')
        .replace(linebreak, '\n');
    var lines = reduced.split('\n');
    var first = lines.shift() || '';
    // const first = lines.find(x => true) || '';
    lines.unshift(first);
    if (first.match(moduleHeader) === null) {
        lines.unshift('module Definitions exposing (..)');
    }
    var processed = lines.join('\n');
    // for (const line of lines) {
    //     console.log(line, line.match(moduleHeader));
    // }
    // console.log(lines);
    // console.log(processed)
    return processed;
    // return reduced;
}
function processError(error) {
    var lines = error.split('\n');
    // .map(s => '-- ' + s);
    var id = function (x) { return x; };
    var patterns = [
        [/\s*-- [\w ]*-*.*/g, (function (s) { return s.replace((/-{3,}.*/g), ''); })],
        [/.*\./g, (function (s) { return '-- ' + s; })],
        [/\d+\|.*/g, id],
        [/\s*\^+\s*/g, id],
        [/^[a-z]+(?: .*)?$|^[A-Z][A-Za-z]+\.\w+(?: .*)?$/, id],
    ];
    // for (let line of lines) {
    lines = lines.map(function (line) {
        var e_1, _a;
        if (line == '')
            return '';
        try {
            for (var patterns_1 = __values(patterns), patterns_1_1 = patterns_1.next(); !patterns_1_1.done; patterns_1_1 = patterns_1.next()) {
                var _b = __read(patterns_1_1.value, 2), p = _b[0], f = _b[1];
                if (line.match(p) !== null) {
                    // console.log(line,p,line.match(p))
                    return f(line);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (patterns_1_1 && !patterns_1_1.done && (_a = patterns_1.return)) _a.call(patterns_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return ['-- ', line].join('');
    });
    var processed = lines.join('\n');
    return processed;
}
function getEvaluationEndpoint() {
    var page = window.location.href;
    switch (page) {
        case 'http://18.237.13.211/':
            return 'http://18.237.13.211:9000/eval';
        case 'http://35.166.255.165/':
        case 'http://localhost:3000/':
            return 'http://35.166.255.165:9000/eval';
        case 'https://playland.netlify.app/':
            return 'https://playland.netlify.app/eval';
        case 'http://playland.engr.oregonstate.edu/':
            return 'http://playland.engr.oregonstate.edu:9000/eval';
        case 'https://playland.engr.oregonstate.edu/':
            return 'https://playland.engr.oregonstate.edu:9000/eval';
        default:
            return 'https://playland.netlify.app/eval';
        // return page + 'eval'
    }
}
// function setupReplEditor(editor: monaco.editor.IStandaloneCodeEditor) {
function setupReplEditor(editors) {
    var outputView = editors.get('repl-output');
    var inputEditor = editors.get('repl-input');
    var outputViewOptions = {
        minimap: { enabled: false },
        lineNumbers: 'off',
        lineNumbersMinChars: 0,
        lineDecorationsWidth: 0,
        // theme: 'hc-black'
    };
    outputView.setValue(lastEvalEditorState);
    outputView.updateOptions(outputViewOptions);
    var inputEditorOptions = __assign({}, outputViewOptions);
    inputEditor.setValue(lastEvalEditorState);
    inputEditor.updateOptions(inputEditorOptions);
    var editor = inputEditor;
    inputEditor.onKeyDown(function (event) {
        var block = function () {
            event.preventDefault();
            event.stopPropagation();
        };
        var clear = function () {
            inputEditor.setValue('> ');
            inputEditor.setPosition({ lineNumber: 1, column: 3 });
        };
        if (locked === true ||
            inputEditor.getPosition().column < 3 ||
            (event.keyCode == 3 &&
                inputEditor.getValue().substring(2).trim().length == 0)) {
            block();
            clear();
            return;
        }
        if (event.keyCode == 3) {
            locked = true;
            var source = editors.get('program-editor').getValue();
            var reduced = processSource(source);
            var evalExpression_1 = inputEditor.getValue().substring(2).trim();
            // if (history.at(history.length - 1) !== evalExpression) {  history.push(evalExpression); }
            if (history.length > 0) {
                if (history[history.length - 1] !== evalExpression_1) {
                    history.push(evalExpression_1);
                }
            }
            else {
                history.push(evalExpression_1);
            }
            historyIdx = history.length;
            block();
            clear();
            var pkg = {
                'language': 'elm',
                'source': reduced
            };
            var evalPackage = __assign(__assign({}, pkg), { expression: evalExpression_1 /*pkg.source.split('\n').at(-1)*/ });
            storage.setItem('session-editor', { source: source });
            var failedCount_1 = 1;
            // axios.post('http://18.237.13.211:9000/eval', evalPackage)
            // axios.post('https://welloffdotingomnipage.iainmon.repl.co/eval', evalPackage)
            // axios.post('https://playland.grape-juice.org/eval', evalPackage)
            // axios.post('https://play-land.netlify.app/eval',evalPackage)
            var endpoint = getEvaluationEndpoint();
            axios.post(endpoint, evalPackage
            //     ,{
            //     // headers: {
            //     //     // 'Access-Control-Allow-Origin': '*',
            //     //     // 'Content-Type': 'application/json',
            //     // }
            // }
            )
                .then(function (res) {
                // editor.updateOptions({ readOnly: false });
                var data = res.data;
                console.log(data);
                if (data['error'] != '') {
                    data['error'] = processError(data['error']);
                }
                var _a = outputView.getPosition(), lineNumber = _a.lineNumber, column = _a.column;
                outputView.setValue(outputView.getValue() + evalExpression_1 + '\n' + (data['evaluated'] || data['error']) + '\n> ');
                outputView.setPosition({ lineNumber: outputView.getModel().getLineCount(), column: 3 });
                outputView.revealLine(outputView.getModel().getLineCount());
                lastEvalEditorState = outputView.getValue();
                lastEditorState = lastEvalEditorState;
                immutableEditorContext = lastEvalEditorState;
                locked = false;
                // elm.ports.interopToElm.send({
                //     tag: "evaluationResponse",
                //     value: data['evaluated']
                // });
            })
                .catch(function (res) {
                console.error(res);
                outputView.setValue("(".concat(failedCount_1, ") ") + 'Endpoint failed to respond.\n' + res.message);
                failedCount_1 += 1;
                locked = false;
            });
        }
        else if (event.keyCode === 1 || event.keyCode === 15) {
            var column = inputEditor.getPosition().column;
            if (column < 4) {
                block();
                return;
            }
        }
        else if (event.keyCode === 16 || event.keyCode === 18) {
            block();
            var inc = (event.keyCode == 16 ? -1 : 1);
            if (historyIdx + inc < 0 || history.length === 0) {
                historyIdx = 0;
            }
            else if (historyIdx + inc >= history.length) {
                historyIdx = history.length;
                if (inputEditor.getValue() == '> ') {
                    return;
                }
                inputEditor.setValue('> ');
                inputEditor.setPosition({ lineNumber: 1, column: 3 });
            }
            else {
                historyIdx += inc;
                var column = inputEditor.getPosition().column;
                var newInput = '> ' + history[historyIdx];
                inputEditor.setValue(newInput);
                inputEditor.setPosition({ lineNumber: 1, column: newInput.length + 1 });
            }
        }
    });
}
layoutInitializer
    .then(function () { return __awaiter(void 0, void 0, void 0, function () {
    var source, _a, _b, editor;
    var e_2, _c;
    return __generator(this, function (_d) {
        setupReplEditor(editors);
        if (storage.getItem('session-editor')) {
            source = storage.getItem('session-editor').source;
            editors.get('program-editor').setValue(source);
        }
        try {
            for (_a = __values(editors.values()), _b = _a.next(); !_b.done; _b = _a.next()) {
                editor = _b.value;
                editor.updateOptions({
                    fontFamily: "'SFMono', 'sf_monoregular','SF Mono', monospace",
                    fontWeight: '500',
                    fontSize: 13,
                    fontLigatures: true,
                    theme: storage.getItem('user-theme') || 'katzenmilch',
                });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return [2 /*return*/];
    });
}); });
// import './styles/LiberationMono-Regular.ttf';
// import './styles/SFMono.ttf';
// import './styles/Fira_Code_v6.2/'
// import './styles/SF-Mono-Light.otf';
// import './styles/SF-Mono-Regular.otf';
// import './styles/fonts/stylesheet.css';
import './styles/style.scss';
import './styles/favicon/favicon.png';
import './styles/favicon/favicon.svg';
window.editors = editors;
